// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML, sendXHR, failedRequest } from 'src/lib/utils.js';


// Binds

// Stateful components

export const ReactPieChart = (props) => {

    let result = Number(props.result);

    let borderClass = ' half-circle--weakness';
    let pieStyles = {};
    let leftStyles = {};
    let rightStyles = {};

    if (isNaN(result)) {
        result = 'N/A';
    } else {
        leftStyles = {
            'transform': `rotate(${result * 3.6}deg)`
        };

        if (result > 66) {
            borderClass = ' half-circle--strength';
        } else if (result > 33) {
            borderClass = ' half-circle--improvement';
        }
        
        if (result <= 50) {
            rightStyles['display'] = 'none';
        } else {
            pieStyles['clip'] = 'rect(auto, auto, auto, auto)';
            rightStyles['transform'] = 'rotate(180deg)';
        }

        result = result + '%';
    }
    
    

    
    return (
        <div className="br-app-pie__wrapper">

            <div className="br-app-pie__label">
                <span className="br-app-pie__result">{result}</span>
                <span className="br-app-pie__label-text">Strengths</span>
            </div>

            <div className="br-app-pie" style={pieStyles}>
                
                <div className={"left-side half-circle" + borderClass} style={leftStyles}></div>

                <div className={"right-side half-circle" + borderClass} style={rightStyles}></div>

            </div>

            <div className="br-app-pie__shadow"></div>
        </div>
    );
};
